import React, { useState, ChangeEvent, FormEvent } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import AuthApi from '../../api/platform/authApi';
import logo from '../../assets/images/logo-transparent.png';
import { useSystemError } from '../../components/Error/SystemErrorContext';
import styles from '../../css/auth/auth.module.css';
import { ResponseErrorModel } from '../../models/system/responseErrorModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import { setCookie } from '../../utils/cookiesUtils';
import { handleError, mapResponseErrorToSystemError, mapUnknownErrorToSystemError } from '../../utils/errorUtils';

const PasswordReset: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const navigate = useNavigate();
  const authCode = searchParams.get('auth_code');
  const [didErrorOccur, setDidErrorOccur] = useState(false);
  const { triggerSystemError } = useSystemError();

  const fetchSetPasswordUser = async (auth_code: string) => {
    try {
      const response = await AuthApi.resetPassword(auth_code, password);
      if (response.success) {
        const data = (response as ResponseSuccessModel).data;
        const platform_token = data.platform_token;
        setCookie('platform_token', platform_token);
        navigate('/main');
      } else {
        handleError(mapResponseErrorToSystemError(response as ResponseErrorModel), setErrorMessage, setDidErrorOccur, triggerSystemError);
      }
    } catch (error: unknown) {
      handleError(mapUnknownErrorToSystemError(error, false), setErrorMessage, setDidErrorOccur, triggerSystemError);
    }
  };

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    setErrorMessage(null);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();

      if (!authCode) {
        setErrorMessage('Authorization code is missing');
        return;
      }

      if (!password) {
        setErrorMessage('Please enter your password');
        return;
      }

      await fetchSetPasswordUser(authCode);
    } catch (error: unknown) {
      handleError(mapUnknownErrorToSystemError(error, false), setErrorMessage, setDidErrorOccur, triggerSystemError);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.card}>
        <img src={logo} alt="Medical Device IQ" className={styles.logo} />
        <h2>Please set your password</h2>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <input
              type="password"
              id="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Password"
            />
          </div>
          <button type="submit">Set Password</button>
          {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
        </form>
      </div>
      <div className={styles.registerLinkOuter}>
        <p>Want to return to the home page? <Link to="/">Click here</Link></p>
      </div>
    </div>
  );
};

export default PasswordReset;
